import React from 'react'
import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { l, Modal } from '@manychat/manyui'

import {
  AiAutomationLayoutActions,
  AiAutomationLayoutSelectors,
} from 'apps/aiAutomation/store/layout'

export const CloseConfirmationModal = () => {
  const dispatch = useAppDispatch()

  const isOpen = useAppSelector(AiAutomationLayoutSelectors.getIsConfirmOpen)

  const onConfirm = () => {
    dispatch(AiAutomationLayoutActions.confirmClosed({ closeSidebar: true }))
  }

  const onCancel = () => {
    dispatch(AiAutomationLayoutActions.confirmClosed({ closeSidebar: false }))
  }

  return (
    <Modal
      width={460}
      open={isOpen}
      disableCloseButton
      disableOverlayClose
      disableEscapeClose
      buttons={[
        {
          onClick: onCancel,
          label: l.translate('Keep Editing'),
        },
        {
          onClick: onConfirm,
          variant: 'danger',
          label: l.translate('Discard & Close'),
        },
      ]}
      title={l.translate('Discard without saving?')}
    >
      <p className="p-x-xs p-y">
        {l.translate('Anything you’ve added will be lost if you leave now.')}
      </p>
    </Modal>
  )
}
